import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { PreferencesContext } from "../../PreferenceContext";

interface AuthGuardProps {
  allowedRoles?: string[];
  disallowedRoles?: string[];
}

const AuthGuard: React.FC<AuthGuardProps> = ({
  allowedRoles,
  disallowedRoles,
}) => {
  const { userContext } = React.useContext(PreferencesContext);
  const role = userContext?.loginDetail?.userRole;

  // If not logged in, redirect to login
  if (
    !userContext ||
    !userContext.loginDetail ||
    !userContext.loginDetail.token
  ) {
    return <Navigate to="/" replace />;
  }

  // If role is allowed
  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to="/dashboard" replace />;
  }

  // If role is explicitly disallowed
  if (disallowedRoles && disallowedRoles.includes(role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default AuthGuard;
